import { FunctionComponent } from 'react';
import App from './ClientVitals';
import './index.css';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

interface InitializeApplicationProps {
  stripe: string;
}

export const InitializeApplication: FunctionComponent<InitializeApplicationProps> = ({ stripe }) => {
  const stripePromise = loadStripe(stripe);

  return (
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
  );
}